export default [
  {
    "teamName": "+",
    "week": "",
    "date": "2019-03-24",
    "vs": "vs",
    "oppositionTeamName": "Long Eaton Storm",
    "friendly": true,
    "start": "2pm",
  },
  {
    "teamName": "+",
    "week": "",
    "date": "2019-03-31",
    "vs": "@",
    "oppositionTeamName": "Harrogate Tigers",
    "friendly": true,
    "start": "12.30pm",
  },
  {
    "teamName": "I",
    "week": "1",
    "date": "2019-04-07",
    "vs": "@",
    "oppositionTeamName": "Halton ‘Robots of Doom’",
    "start": "12pm",
    "line": "WEEK 1 : APRIL 7th  – @ Halton ‘Robots of Doom’ (12pm start)"
  },
  {
    "teamName": "II",
    "week": "1",
    "date": "2019-04-07",
    "vs": "@",
    "oppositionTeamName": "Manchester Bee’s",
    "start": "12pm",
    "line": "WEEK 1 : APRIL 7th  – @ Manchester Bee’s (12pm start)"
  },
  {
    "teamName": "I",
    "week": "2",
    "date": "2019-04-14",
    "vs": "@",
    "oppositionTeamName": "Manchester Bee’s",
    "start": "12pm",
    "line": "WEEK 2 : APRIL 14th  – @ Manchester Bee’s (12pm start)"
  },
  {
    "teamName": "II",
    "week": "2",
    "date": "2019-04-14",
    "vs": "@",
    "oppositionTeamName": "Newcastle Nighthawks",
    "start": "12pm",
    "line": "WEEK 2 : APRIL 14th  – @ Newcastle Nighthawks (12pm start)"
  },
  {
    "date": "2019-04-21",
    "bye": "LEAGUE BYE WEEK - EASTER",
    "line": "LEAGUE BYE WEEK - EASTER 21st APRIL"
  },
  {
    "teamName": "I",
    "week": "3",
    "date": "2019-04-28",
    "vs": "@",
    "oppositionTeamName": "Manchester A’s",
    "start": "12pm",
    "line": "WEEK 3 : APRIL 28th  – @ Manchester A’s (12pm start)"
  },
  {
    "teamName": "II",
    "week": "3",
    "date": "2019-04-28",
    "vs": "vs",
    "oppositionTeamName": "Manchester Bee’s",
    "start": "1pm",
    "line": "WEEK 3 : APRIL 28th  – Vs Manchester Bee’s (1pm start)"
  },
  {
    "date": "2019-05-05",
    "bye": "LEAGUE BYE WEEK",
    "line": "LEAGUE BYE WEEK 5th MAY"
  },
  {
    "teamName": "I",
    "week": "4",
    "date": "2019-05-12",
    "vs": "@",
    "oppositionTeamName": "Sheffield Bladerunners II",
    "start": "1pm",
    "line": "WEEK 4 : MAY 12th @ Sheffield Bladerunners II (1pm start)"
  },
  {
    "teamName": "II",
    "week": "4",
    "date": "2019-05-12",
    "vs": "vs",
    "oppositionTeamName": "Sheffield Bladerunners I",
    "start": "1pm",
    "line": "WEEK 4 : MAY 12th Vs Sheffield Bladerunners II (1pm start)"
  },
  {
    "teamName": "I",
    "week": "5",
    "date": "2019-05-19",
    "vs": "@",
    "oppositionTeamName": "Newcastle Nighthawks",
    "start": "1pm",
    "line": "WEEK 5 : MAY 19th @ Newcastle Nighthawks (1pm start)"
  },
  {
    "teamName": "II",
    "week": "5",
    "date": "2019-05-19",
    "vs": "@",
    "oppositionTeamName": "Hull Scorpions",
    "start": "12pm",
    "line": "WEEK 5 : MAY 19th @ Hull Scorpions (12 pm start)"
  },
  {
    "date": "2019-05-26",
    "bye": "LEAGUE BYE WEEK",
    "line": "LEAGUE BYE WEEK 26th MAY"
  },
  {
    "teamName": "I",
    "date": "2019-06-02",
    "vs": "vs",
    "oppositionTeamName": "Worcester Sorcerers",
    "start": "1pm",
    "friendly": true,
    "line": "(BYE WEEK 2nd JUNE)"
  },
  {
    "teamName": "II",
    "week": "6",
    "date": "2019-06-02",
    "vs": "vs",
    "oppositionTeamName": "Newcastle Nighthawks",
    "start": "1pm",
    "line": "WEEK 6 : JUNE 2nd   Vs  Newcastle Nighthawks (1pm start)"
  },
  {
    "teamName": "I",
    "week": "7",
    "date": "2019-06-09",
    "vs": "@",
    "oppositionTeamName": "Manchester Bee’s",
    "start": "12pm",
    "line": "WEEK 7 : JUNE 9th  – @ Manchester Bee’s (12pm start)"
  },
  {
    "teamName": "II",
    "week": "7",
    "date": "2019-06-09",
    "vs": "vs",
    "oppositionTeamName": "Manchester A’s",
    "start": "1pm",
    "line": "WEEK 7 : JUNE 9th  – Vs Manchester A’s (1pm start)"
  },
  {
    "week": "8",
    "date": "2019-06-16",
    "bye": "BYE WEEK - FATHER’S DAY - poss. friendly @ Hull",
    "line": "(BYE WEEK JUNE 16th  FATHER’S DAY) -poss. Friendly at HULL"
  },
  {
    "teamName": "+",
    "week": "9",
    "date": "2019-06-23",
    "vs": "@",
    "oppositionTeamName": "Wolverhampton Wolves",
    "start": "12pm",
    "friendly": true,
    "line": "(BYE WEEK JUNE 23rd) – Friendly @ Wolverhampton Wolves"
  },
  {
    "date": "2019-06-30",
    "bye": "LEAGUE BYE WEEK - MLB LONDON",
    "line": "LEAGUE BYE WEEK June 30th MLB LONDON"
  },
  {
    "teamName": "I",
    "week": "10",
    "date": "2019-07-07",
    "vs": "vs",
    "oppositionTeamName": "Sheffield Bladerunners II",
    "start": "1pm",
    "line": "WEEK 10 : JULY 7th – Vs Sheffield Bladerunners II (1pm start)"
  },
  {
    "teamName": "II",
    "week": "10",
    "date": "2019-07-07",
    "vs": "@",
    "oppositionTeamName": "Sheffield Bladerunners I",
    "start": "1pm",
    "line": "WEEK 10 : JULY 7th – @ Sheffield Bladerunners II (1pm start)"
  },
  {
    "teamName": "I",
    "week": "11",
    "date": "2019-07-14",
    "vs": "vs",
    "oppositionTeamName": "Newcastle Nighthawks",
    "start": "1pm",
    "line": "WEEK 11 : JULY 14th – Vs Newcastle Nighthawks (1pm start)"
  },
  {
    "teamName": "II",
    "week": "11",
    "date": "2019-07-14",
    "vs": "vs",
    "oppositionTeamName": "Harrogate Tigers",
    "start": "1pm",
    "line": "WEEK 11 : JULY 14th – Vs Harrogate Tigers (1pm start)"
  },
  {
    "teamName": "I",
    "week": "12",
    "date": "2019-07-21",
    "vs": "@",
    "oppositionTeamName": "Newcastle Nighthawks",
    "start": "1pm",
    "line": "WEEK 12 : JULY 21st  - @ Newcastle Nighthawks ( 1pm start )"
  },
  {
    "teamName": "II",
    "week": "12",
    "date": "2019-07-21",
    "vs": "@",
    "oppositionTeamName": "Liverpool Twojans",
    "start": "12pm",
    "line": "WEEK 12 : JULY 21st  - @ Liverpool Twojans ( 12pm start )"
  },
  {
    "teamName": "I",
    "week": "13",
    "date": "2019-07-28",
    "vs": "vs",
    "oppositionTeamName": "Liverpool Twojans",
    "start": "1pm",
    "line": "WEEK 13 : JULY 28th  - Vs Liverpool Twojans (1pm start)"
  },
  {
    "teamName": "II",
    "week": "13",
    "date": "2019-07-28",
    "vs": "vs",
    "oppositionTeamName": "Manchester Bee’s",
    "start": "1pm",
    "line": "WEEK 13 : JULY 28th  - Vs Manchester Bee’s (1pm start)"
  },
  {
    "teamName": "I",
    "week": "14",
    "date": "2019-08-04",
    "vs": "@",
    "oppositionTeamName": "Harrogate Tigers",
    "start": "12pm",
    "line": "WEEK 14 : AUGUST 4th  - @ Harrogate Tigers (12pm start)"
  },
  {
    "teamName": "II",
    "date": "2019-08-04",
    "vs": "@",
    "oppositionTeamName": "Worcester Sorcerers",
    "start": "12pm",
    "friendly": true,
    "line": "(BYE WEEK 2nd JUNE)"
  },
  {
    "teamName": "I",
    "week": "15",
    "date": "2019-08-11",
    "vs": "vs",
    "oppositionTeamName": "Newcastle Nighthawks",
    "start": "1pm",
    "line": "WEEK 15 : AUGUST 11th – Vs Newcastle Nighthawks (1pm start)"
  },
  {
    "teamName": "II",
    "week": "15",
    "date": "2019-08-11",
    "vs": "@",
    "oppositionTeamName": "Manchester Bee’s",
    "start": "12pm",
    "line": "WEEK 15 : AUGUST 11th – @ Manchester Bee’s (12pm start)"
  },
  {
    "teamName": "I",
    "week": "16",
    "date": "2019-08-18",
    "vs": "vs",
    "oppositionTeamName": "Sheffield Bladerunners II",
    "start": "1pm",
    "line": "WEEK 16 : AUGUST 18th– Vs Sheffield Bladerunners II (1pm start)"
  },
  {
    "teamName": "II",
    "week": "16",
    "date": "2019-08-18",
    "vs": "@",
    "oppositionTeamName": "Sheffield Bladerunners I",
    "start": "1pm",
    "line": "WEEK 16 : AUGUST 18th– @ Sheffield Bladerunners II (1pm start)"
  },
  {
    "date": "2019-08-25",
    "bye": "LEAGUE BYE WEEK AUGUST",
    "line": "LEAGUE BYE WEEK AUGUST  25th "
  },
  {
    "teamName": "I",
    "week": "17",
    "date": "2019-09-01",
    "vs": "vs",
    "oppositionTeamName": "Manchester Bee’s",
    "start": "12pm",
    "line": "WEEK 17 : SEPTEMBER 1st  Vs Manchester Bee’s (12pm start)"
  },
  {
    "teamName": "II",
    "week": "17",
    "date": "2019-09-01",
    "vs": "@",
    "oppositionTeamName": "Newcastle Nighthawks",
    "start": "12pm",
    "line": "WEEK 17 : SEPTEMBER 1st  @ Newcastle Nighthawks (12pm start)"
  }
];
